module.exports = __webpack_public_path__ + "img/icons8-vue-js.b00020dd.svg";